import '../base';
import '../components/product/product-suitability';
